"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_startswith_1 = __importDefault(require("lodash.startswith"));

function startsWith(value, target) {
  return lodash_startswith_1.default(value, target);
}

exports.startsWith = startsWith;